import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';

import { type CustomAttributeType } from 'hb-react/frontoffice/apps/Mentoring/types';
import { CustomAttribute } from 'hb-react/shared/components/formik/components/inputs';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';
import { HtmlContent } from 'hb-react/shared/components/HtmlContent';

interface MentoringFormContentProps {
  applicationDescription: string;
  attributes: Array<CustomAttributeType>;
  onCancel?: () => void;
  submitButtonLabel?: string;
  title: string;
}

export const MentoringFormContent = ({
  attributes,
  title,
  onCancel,
  applicationDescription,
  submitButtonLabel = __('Send'),
}: MentoringFormContentProps) => {
  const hasRequiredAttributes = attributes.some((attr) => attr.required);

  return (
    <Card pb={{ _: 6, m: 8 }} noBorderRadiusOnSmallScreen>
      <TitleStyled as="h1">{title}</TitleStyled>
      <Box mt={4} className="ckeditor-content--reset">
        <HtmlContent content={applicationDescription} />
      </Box>
      {hasRequiredAttributes && <RequiredExplanation mt={2} mb={4} />}
      {attributes.map((customAttribute) => (
        <CustomAttribute
          key={customAttribute.name}
          name={customAttribute.name}
          customAttribute={customAttribute}
        />
      ))}
      <Box justifyContent="flex-end">
        {onCancel && (
          <Button variant="secondary" onClick={onCancel} mr={4}>
            {__('Cancel')}
          </Button>
        )}
        <Button type="submit">{submitButtonLabel}</Button>
      </Box>
    </Card>
  );
};

const TitleStyled = styled(Box).attrs({
  font: 'h3-semibold',
  display: 'block',
})`
  overflow-wrap: anywhere;
`;
